import { keyBy } from '@src/utils/functions/utils'

import Product from '../../domains/Product'
import { INTERNAL_INVENTORY_API, SvDetails } from '../../domains/ProductPurchaseInfo'
import { InventoryResponce, getInventory } from '../inventoryService/inventory.service'

export async function getVariantDetailsByIdForProductVariants(product: Product): Promise<Record<number, SvDetails>> {
  if (product.variants?.length === 0) return {}
  const variantIds = product.variants?.map(variant => variant.id).join(',')
  const inventoryData: Record<string, InventoryResponce> = await getInventory({ variantIds })
  const variantsMap = keyBy(product.variants, 'id')

  const result = Object.entries(inventoryData).reduce((acc, [key, value]) => {
    const variant = variantsMap[key]
    return {
      ...acc,
      [key]: {
        id: key,
        inventoryInfoSource: INTERNAL_INVENTORY_API,
        inventoryType: value?.inventoryType,
        preOrderShippingDate: value?.tags?.preOrderShippingDate,
        price: variant?.price,
        quantityAvailable: value?.available,
      },
    }
  }, {})

  return result
}
